export default __webpack_public_path__ + "static/media/subjects-white.673ef2a9.svg";